export default __webpack_public_path__ + "static/media/photo--sm--94.4418607e.jpg";